import { createSlice } from '@reduxjs/toolkit'
import { Room } from '../types/room'

interface RoomsState {
  rooms: Room[]
  singleRoom: Room | null
  isLoading: boolean
}

const initialState: RoomsState = {
  rooms: [],
  singleRoom: null,
  isLoading: false,
}

export const roomsSlice = createSlice({
  name: 'rooms',
  initialState,
  reducers: {
    setRooms: (state, action) => {
      state.rooms = action.payload
    },
    setSingleRoom: (state, action) => {
      state.singleRoom = action.payload
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
    addRoom: (state, action) => {
      state.rooms.push(action.payload)
    },
    updateRoom: (state, action) => {
      const index = state.rooms.findIndex(room => room._id === action.payload._id)
      if (index !== -1) {
        state.rooms[index] = action.payload
      }
    },
    removeRoom: (state, action) => {
      state.rooms = state.rooms.filter(room => room._id !== action.payload)
    },
  },
})

export const { 
  setRooms, 
  setSingleRoom, 
  setLoading, 
  addRoom, 
  updateRoom, 
  removeRoom 
} = roomsSlice.actions

export default roomsSlice.reducer
